import firebase from "firebase/app";

const remove = firebase.firestore.FieldValue.arrayRemove;
export const unfollow = async (toUnFollow, currentUserId) => {
  await firebase
    .firestore()
    .collection("followers")
    .doc(toUnFollow)
    .update({ followers: remove(currentUserId) });
};
